module.exports = __webpack_public_path__ + "img/news-single.8b97c611.jpg";